import React from 'react'
import {inject, observer} from 'mobx-react'

export default inject("rootstore", "langstore")(observer((props) => {

    const { rootstore, langstore } = props;

    if (rootstore.routeParamsCurrent.unproctected) {
        return;
    }

    const currentRoute = rootstore.routeParamsCurrent?.routeId || '';

    const navItems = [
        {
            icon: 'fas fa-cart-arrow-down',
            route: '/ordini',
            label: langstore.t('', 'Archivio Ordini'),
        },
        {
            icon: 'fas fa-user',
            route: '/profile',
            label: langstore.t('profile', 'Profilo'),
        },
        {
            icon: 'fa fa-envelope',
            route: '/comunicazioni',
            label: langstore.t('', 'Comunicazioni'),
        },
    ];

    return (
        <nav className="sidebar_menu_bottom mobile-app-nav" aria-label={langstore.t('nav_mobile', 'Navigazione mobile')}>
            {navItems.map((item) => {
                const isActive = currentRoute === item.route;
                return (
                    <div
                        key={item.route}
                        className={isActive ? 'mobile-nav-item active' : 'mobile-nav-item'}
                        aria-label={item.label}
                        aria-current={isActive ? 'page' : undefined}
                        role="button"
                        onClick={() => {
                            rootstore.uiSidebarToggle(false);
                            rootstore.routeChange(item.route);
                        }}
                    >
                        <i className={`fa ${item.icon}`}/>
                    </div>
                );
            })}
            <div
                className="mobile-nav-item"
                aria-label={langstore.t('ui_menu', 'Menu')}
                role="button"
                onClick={() => rootstore.uiSidebarToggle()}
            >
                <i className="fa fa-bars"/>
            </div>
        </nav>
    )
}));
